export default __webpack_public_path__ + "static/media/logo512.aaea6bb9.png";